var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconSmartphone42Gn73Qjud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFEFE4;}\n\t.st2{fill:#69EBFC;}\n\t.st3{fill:#5FD4E3;}\n\t.st4{fill:#A1F1FC;}\n\t.st5{fill:#D476E2;}\n\t.st6{fill:#B665C2;}\n\t.st7{fill:#EA82FA;}\n\t.st8{fill:#FFF7F2;}\n\t.st9{fill:#FF8354;}\n\t.st10{fill:#FFA172;}\n\t.st11{fill:#6770E6;}\n\t.st12{fill:#5861C7;}\n\t.st13{fill:#E0734A;}\n\t.st14{fill:#EDD4C2;}\n\t.st15{fill:#CC6944;}\n\t.st16{fill:#858EFF;}\n\t.st17{fill:#C76642;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#FFDEC7;}\n\t.st20{fill:#4E56B0;}\n\t.st21{fill:#94529E;}\n\t.st22{fill:#41B6C5;}\n\t.st23{fill:#9847A4;}\n\t.st24{fill:#C2552C;}\n\t.st25{fill:#CFB6A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193,256H63c-8.837,0-16-7.163-16-16V16c0-8.837,7.163-16,16-16h130c8.837,0,16,7.163,16,16v224 C209,248.837,201.837,256,193,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193,256H63c-8.837,0-16-7.163-16-16V16c0-8.837,7.163-16,16-16h130c8.837,0,16,7.163,16,16v224 C209,248.837,201.837,256,193,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193,0H63c-8.837,0-16,7.163-16,16v6c0-8.837,7.163-16,16-16h130c8.837,0,16,7.163,16,16v-6 C209,7.163,201.837,0,193,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M57,238V30c0-4.418,3.582-8,8-8h126c4.418,0,8,3.582,8,8v208c0,4.418-3.582,8-8,8H65 C60.582,246,57,242.418,57,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65,246h126c4.418,0,8-3.582,8-8v-39.404L57,134v104C57,242.418,60.582,246,65,246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67,50L67,50c0-4.418,3.582-8,8-8h106c4.418,0,8,3.582,8,8l0,0c0,4.418-3.582,8-8,8H75 C70.582,58,67,54.418,67,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156,15h-56c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4,4-4h56c2.209,0,4,1.791,4,4v0 C160,13.209,158.209,15,156,15z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 170,
    cy: 11,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 75,
    cy: 50,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83,236h-8c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v8 C91,232.418,87.418,236,83,236z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 79,
    cy: 224,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M115.667,236h-8c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v8 C123.667,232.418,120.085,236,115.667,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M111.667,224v-5h11.931c-0.493-3.945-3.852-7-7.931-7h-8c-2.209,0-4.209,0.895-5.657,2.343L111.667,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.667,219v5l3.521,3.521l-8.424,8.424c0.297,0.033,0.597,0.054,0.903,0.054h8c4.418,0,8-3.582,8-8v-8 c0-0.339-0.028-0.672-0.069-1H111.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.333,236h-8c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v8 C156.333,232.418,152.752,236,148.333,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M181,236h-8c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v8 C189,232.418,185.418,236,181,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M173,232c-2.206,0-4-1.794-4-4v-8c0-2.206,1.794-4,4-4h8c2.206,0,4,1.794,4,4v8c0,2.206-1.794,4-4,4H173z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 111.667,
    cy: 224,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.414,223.3l-9.414-5.021c-0.528-0.282-1.166,0.101-1.166,0.7v10.042c0,0.598,0.638,0.981,1.166,0.7 l9.414-5.021C150.973,224.401,150.973,223.599,150.414,223.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 128,
    cy: 99,
    r: 21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,136h-48c-2.209,0-4-1.791-4-4l0,0c0-2.209,1.791-4,4-4h48c2.209,0,4,1.791,4,4l0,0 C156,134.209,154.209,136,152,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193,250H63c-8.837,0-16-7.163-16-16v6c0,8.837,7.163,16,16,16h130c8.837,0,16-7.163,16-16v-6 C209,242.837,201.837,250,193,250z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconSmartphone42Gn73Qjud);
export default __webpack_public_path__ + "static/media/reshot-icon-smartphone-42GN73QJUD.9e0735165f40a81bf036942f5d637eea.svg";
export { ForwardRef as ReactComponent };